import { Injectable, Injector } from '@angular/core';
import { ApplicationInsights, IConfiguration } from '@microsoft/applicationinsights-web';
import { APP_INSIGHTS_CONFIG } from '../core/globals';
import { InjectorInstance } from '../core/injector-instance';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;

  constructor(
    private injector?: Injector
  ) {
    if (!InjectorInstance.hasInstance && this.injector) {
      InjectorInstance.setInstance(this.injector);
    }
    this.injector = this.injector || InjectorInstance;
    const config = this.injector.get<IConfiguration>(APP_INSIGHTS_CONFIG);
    this.appInsights = new ApplicationInsights({ config });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string, properties?: {[name: string]: string}, measurements?: any, duration?: number) {
    this.appInsights.trackPageView({ name, uri: url, properties: { ...properties, duration } });
  }

  logEvent(name: string, properties?: {[name: string]: string}, measurements?: any) {
    this.appInsights.trackEvent({ name }, properties);
  }

  logException(exception: Error, properties?: {[name: string]: string}) {
    this.appInsights.trackException({ exception }, properties);
  }

  logMetric(name: string, average: number, properties?: {[name: string]: string}) {
    this.appInsights.trackMetric({ name, average }, properties);
  }
}
